import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import FadeIn from "./FadeIn";

export default function MatchingNetworkSection() {
  return (
    <section id="clarity" className="pt-16 md:pt-20 pb-12 md:pb-16 px-6 md:px-12 bg-white" data-testid="clarity-section">
      <div className="max-w-5xl mx-auto">
        <div className="grid md:grid-cols-2 gap-4 md:gap-16 items-start">
          <div>
            <FadeIn>
              <p className="text-xs font-subhead uppercase tracking-widest text-gray-400 mb-4">What is HAEVN</p>
              <h2 className="font-headline text-4xl md:text-[2.75rem] text-haevn-navy mb-4 leading-[1.1]">
                HAEVN isn't a dating app. It's a matching network.
              </h2>
              <p className="text-base md:text-lg text-haevn-navy/70 font-subhead leading-relaxed mb-6">
                You don't search profiles. The network finds your 80%+ matches.
              </p>
            </FadeIn>
            <FadeIn delay={100}>
              <p className="hidden md:block text-base md:text-lg text-gray-600 font-body leading-relaxed">
                You define what you're looking for, and the system surfaces people looking for the same thing.
              </p>
            </FadeIn>
          </div>
          <div>
            <FadeIn delay={200}>
              <div className="mb-6">
                <p className="font-headline text-2xl text-haevn-navy mb-1"><span className="font-subhead font-bold text-haevn-teal">matching network</span></p>
                <p className="text-sm text-gray-400 font-body italic mb-1">/ˈmaCHiNG ˈnetˌwərk/</p>
                <p className="text-xs text-gray-400 font-subhead uppercase tracking-wider mb-4">noun</p>
                <p className="text-sm text-gray-600 font-body leading-relaxed mb-4">
                  A system where people define what they want, get matched based on compatibility, and only connect when alignment is high.
                </p>
                <p className="text-xs text-gray-400 font-subhead uppercase tracking-wider mb-2">Example:</p>
                <p className="text-sm text-gray-500 font-body italic leading-relaxed border-l-2 border-gray-200 pl-4">
                  "Instead of swiping through profiles, you join a matching network and get notified when there's a match."
                </p>
              </div>
            </FadeIn>
            <FadeIn delay={300}>
              <Link to="/anatomy" className="inline-flex items-center gap-2 text-sm font-subhead text-haevn-teal hover:text-haevn-navy transition-colors duration-200 group" data-testid="anatomy-page-link">
                Learn More
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
              </Link>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>
  );
}
